import React, { useCallback } from "react";
import { useCurrentRefinements } from "react-instantsearch";

const Clear = () => {
    const { items, refine } = useCurrentRefinements();
    const handleClear = useCallback(() => {
        refine(items);
        document.querySelectorAll(".configurator__select").forEach((select) => {
            select.value = select.options[0].value;
            if (select.options[0].value !== "select") {
                select.dispatchEvent(new Event("change", { bubbles: true }));
            }
        });
    }, [items, refine]);
    return (
        <button className="configurator__clear" onClick={handleClear}>
            <svg><use xlinkHref="#cross-sign-square-icon" /></svg>
            Clear all fields
        </button>
    );
};
export default Clear;